
import moment from 'moment';

const state = {
  times: [
    { text: 'all', value: null, },
    { text: 'last_24h', value: moment().subtract(24, 'hours').unix()},
    { text: 'past_week', value: moment().subtract(1, 'weeks').unix() },
    { text: 'past_month', value: moment().subtract(1, 'months').unix() },
    { text: 'past_year', value: moment().subtract(1, 'years').unix() }
  ],
}

export default {
  namespaced: true,
  state,
};